<template>
  <div>
    <RevCard
      v-if="!isFetchingPending"
      class="flex flex-col justify-between p-20"
    >
      <div class="heading-1 mb-12">
        {{ i18n(translations.helperBlockTitle) }}
      </div>

      <FormattedMessage :definition="translations.helperBlockContact">
        <template #activationEmailLink>
          <RevLink target="_blank" :to="ACTIVATION_LINK">
            {{ i18n(translations.helperBlockLinkLabel) }}
          </RevLink>
        </template>
      </FormattedMessage>
    </RevCard>
    <RevCard
      v-if="isFetchingPending"
      class="flex flex-col justify-between p-20"
    >
      <RevSkeleton class="mb-8" height="12px" shape="line" width="50%" />
      <RevSkeleton class="mb-16" height="12px" shape="line" width="80%" />
      <RevSkeleton class="mb-8" height="12px" shape="line" width="100%" />
      <RevSkeleton class="mb-8" height="12px" shape="line" width="100%" />
      <RevSkeleton class="mb-16" height="12px" shape="line" width="100%" />
      <RevSkeleton height="4rem" shape="rectangle" width="100%" />
    </RevCard>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevCard } from '@ds/components/Card'
import { RevLink } from '@ds/components/Link'
import { RevSkeleton } from '@ds/components/Skeleton'

import { getExternalLinkList } from '~/constants/externalLinks'

import translations from './OnboardingHelp.translations'

const i18n = useI18n()
const currentLocale = useI18nLocale()

defineProps<{
  isFetchingPending: boolean
}>()

const ACTIVATION_LINK = computed(
  () => getExternalLinkList(currentLocale).ACTIVATION_LINK,
)
</script>
